const apiMessages = {
  // messages such as "Request failed with status code 404" should be handled here

  // SignIn:
  'Incorrect username or password.': 'incorrect-username-or-password',

  // Migration:
  'Email used by different user':'email-used-by-different-user',

  // SignUp:
  'User is already registered!': 'user-is-already-registered',

  //Common:
  'User does not exist.': 'user-does-not-exist',
  'UserMigration failed with error Unexpected end of JSON input.': 'user-migration-failed-with-error-unexpected-end-of-json-input',
};
type Keys = keyof typeof apiMessages;
export const apiMessage = (key: Keys):string => {
  const message = apiMessages[key];
  return message ? message : "generic-api-message";
}
export default apiMessage;
